import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import SideNavbar from './helpers/SideNavbar';
import defaultimage from "../assets/default-image.png";
import { Modal, Button, Card, InputGroup, Form } from 'react-bootstrap';
import SubscriptionStatus from './subscriptionstatus';
import { featureLimitsAPI } from '../apis/featureLimits';
import { FaCopy, FaGift, FaShare, FaHome, FaUser, FaTools, FaTrophy, FaChartLine, FaStar, FaQuestionCircle, FaFileAlt, FaSignOutAlt, FaPlus, FaRobot, FaBell, FaEye, FaPlay, FaSync, FaCheckCircle, FaClock } from 'react-icons/fa';
import { BsFilePostFill } from "react-icons/bs";
import { PiImageBrokenFill } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';



const Home = () => {
  const navigate = useNavigate();

  // Add CSS animation for accordion fadeIn effect
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  // Initialize userProfile from localStorage immediately to show name right away
  const [userProfile, setUserProfile] = useState(() => {
    const storedProfile = localStorage.getItem('userProfile');
    if (storedProfile) {
      try {
        return JSON.parse(storedProfile);
      } catch (e) {
        return null;
      }
    }
    return null;
  });
  const [loading, setLoading] = useState(true);
  const [loginType, setLoginType] = useState("User"); // State to store login type
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [selectedScopes, setSelectedScopes] = useState([]);
  const [referralData, setReferralData] = useState({
    referralCode: '',
    referralUrl: '',
    totalReferrals: 0,
    successfulReferrals: 0,
    pendingReferrals: 0,
    totalCredits: 0,
    availableCredits: 0
  });
  const [knackFeeds, setKnackFeeds] = useState([]);
  const [knackFeedsLoading, setKnackFeedsLoading] = useState(false);
  const [referralLoading, setReferralLoading] = useState(false);
  const [todaysPosts, setTodaysPosts] = useState([]);
  const [postsLoading, setPostsLoading] = useState(true);
  const [topPerformingPosts, setTopPerformingPosts] = useState([]);
  const [topPostsLoading, setTopPostsLoading] = useState(true);
  const [pendingPosts, setPendingPosts] = useState([]);
  const [pendingPostsLoading, setPendingPostsLoading] = useState(true);
  const [approvedPosts, setApprovedPosts] = useState([]);
  const [approvedPostsLoading, setApprovedPostsLoading] = useState(true);
  const [knackChallenges, setKnackChallenges] = useState([]);
  const [challengesLoading, setChallengesLoading] = useState(true);
  const [usageLimits, setUsageLimits] = useState({
    knack_feeds: { used: 0, limit: 10 },
    manual_posts: { used: 0, limit: 20 },
    schedule_days: { used: 0, limit: 30 }
  });
  const [usageLimitsLoading, setUsageLimitsLoading] = useState(true);
  const [isReferralAccordionOpen, setIsReferralAccordionOpen] = useState(false);
  const [knackMoments, setKnackMoments] = useState([]);
  const [knackMomentsLoading, setKnackMomentsLoading] = useState(true);
  const [linkedInProfileUrl, setLinkedInProfileUrl] = useState(null);
  const UserID = localStorage.getItem('UserID');
  const IsActive = localStorage.getItem('IsActive');
  console.log("19", typeof IsActive)
  const Token = localStorage.getItem('AccessToken');

  // Authentication check - redirect to login if not authenticated
  // Note: Token might not be set immediately after login (it's fetched in useEffect below)
  // So we only check UserID here, and let the profile fetch handle Token validation
  useEffect(() => {
    // Only check UserID - Token will be set after profile is fetched
    if (!UserID) {
      console.log('User not authenticated (no UserID), redirecting to login');
      localStorage.clear(); // Clear any remaining data
      navigate('/Login');
    }
  }, [UserID, navigate]);

  // Helper function to check if media is a video
  const isVideoFile = (mediaPath) => {
    if (!mediaPath || typeof mediaPath !== 'string') return false;
    const pathWithoutQuery = mediaPath.split('?')[0];
    const fileExtension = pathWithoutQuery.split('.').pop()?.toLowerCase();
    const isVideo = ['mp4', 'mov', 'avi', 'webm', 'mkv', 'm4v', 'flv', 'wmv'].includes(fileExtension);
    // Also check if the filename contains 'video' (for cases like "1764246552388-video.mp4")
    const hasVideoInName = pathWithoutQuery.toLowerCase().includes('video');
    return isVideo || hasVideoInName;
  };

  // Helper function to get media URL
  const getMediaUrl = (mediaPath) => {
    if (!mediaPath) return null;
    const normalizedPath = mediaPath.replace(/\\/g, '/');
    const isFullUrl = normalizedPath.startsWith('http://') || normalizedPath.startsWith('https://');
    const isAzureBlobUrl = normalizedPath.startsWith("https://sqlvaicpdkscvwnsyc.blob.core.windows.net/");
    const isLinkedInAsset = normalizedPath.includes('linkedin.com') || normalizedPath.includes('media.licdn.com');
    
    if (isFullUrl || isAzureBlobUrl || isLinkedInAsset) {
      return normalizedPath;
    } else {
      return `${process.env.REACT_APP_API_BASE_URL}/${normalizedPath}`;
    }
  };

  // Function to save accessToken and profile data to localStorage
  const saveToLocalStorage = (profileData) => {
    localStorage.setItem('AccessToken', profileData[0]?.AccessToken);
    localStorage.setItem('Tokenid', profileData[0]?.Tokenid);
    localStorage.setItem('FullName', profileData[0]?.FullName);
    localStorage.setItem('Email', profileData[0]?.Email);
    localStorage.setItem('userProfile', JSON.stringify(profileData));
    localStorage.setItem('ReferralCode', profileData[0]?.referral_code);
    localStorage.setItem('CountryCode', profileData[0]?.CountryCode);
  };

  // Fetch profile data based on UserID in the URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenID = urlParams.get('tokenID'); // Get tokenID from URL

    if (UserID) {
      // Fetch profile info from the backend
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-profile-info`, {
        params: { UserID }
      })
        .then((response) => {
          console.log("API Response:", response.data); // Log the API response

          const profiles = response.data;
          console.log(profiles);

          // Check if profiles data is available
          if (profiles && profiles.length > 0) {
            // Save to localStorage
            saveToLocalStorage(profiles);
            setUserProfile(profiles);
          } else {
            console.error('No matching profile found');
            // If profile fetch fails, user might not be authenticated
            // Clear data and redirect to login
            localStorage.clear();
            navigate('/Login');
            return;
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching profile info:', error);
          // If profile fetch fails (401, 403, etc.), user is not authenticated
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.clear();
            navigate('/Login');
          }
          setLoading(false);
        });

      // Load referral data
      loadReferralData();

      // Load today's posts
      loadTodaysPosts();

      // Load top-performing posts
      loadTopPerformingPosts();

      // Load pending posts
      loadPendingPosts();
      // Load approved posts
      loadApprovedPosts();

      // Load KnackFeeds
      loadKnackFeeds();

      // Load KnackChallenges
      loadKnackChallenges();

      // Load usage limits
      loadUsageLimits();
      // Load Knack Moments
      loadKnackMoments();

      // Fetch LinkedIn profile image
      const fetchLinkedInProfile = async () => {
        if (!UserID) return;
        try {
          const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
          const url = `${API_BASE_URL}/api/GetAllSocialMediaAccounts/${UserID}`;
          const response = await fetch(url);
          if (response.ok) {
            const accounts = await response.json();
            const linkedInAccount = accounts?.find(acc => acc.PlatformId === 1);
            if (linkedInAccount?.LinkedInProfileUrl) {
              setLinkedInProfileUrl(linkedInAccount.LinkedInProfileUrl);
            }
          }
        } catch (error) {
          console.error('Error fetching LinkedIn profile:', error);
        }
      };
      fetchLinkedInProfile();

      // Check for credit redemptions
      checkCreditRedemptions();

      // Check for refresh triggers immediately on mount
      const refreshTrigger = localStorage.getItem('dashboardRefreshTrigger');
      if (refreshTrigger) {
        console.log('Refresh trigger found on mount, refreshing data...');
        setTimeout(() => {
          loadKnackFeeds();
          loadTodaysPosts();
          loadTopPerformingPosts();
          loadPendingPosts();
          loadApprovedPosts();
          loadKnackChallenges();
          loadKnackMoments();
          loadUsageLimits();
          localStorage.removeItem('dashboardRefreshTrigger');
        }, 1000);
      }
    } else {
      setLoading(false);
    }
  }, []);

 
  // Check for recent credit redemptions and show notifications
  const checkCreditRedemptions = async () => {
    try {
      // Check if there's a redemption notification in localStorage
      const redemptionNotification = localStorage.getItem('creditRedemptionNotification');
      if (redemptionNotification) {
        const redemption = JSON.parse(redemptionNotification);

        // Show success notification
        Swal.fire({
          icon: 'success',
          title: 'Credits Redeemed! 🎉',
          html: `
            <div style="text-align: left;">
              <p><strong>Credits Redeemed:</strong> ${redemption.creditsRedeemed}</p>
              <p><strong>Days Added:</strong> ${redemption.daysAdded} days</p>
              <p><strong>New End Date:</strong> ${new Date(redemption.newEndDate).toLocaleDateString()}</p>
              <p><strong>Remaining Credits:</strong> ${redemption.remainingCredits}</p>
            </div>
          `,
          confirmButtonText: 'Awesome!',
          confirmButtonColor: '#2e3192'
        });

        // Clear the notification
        localStorage.removeItem('creditRedemptionNotification');
      }
    } catch (error) {
      console.error('Error checking credit redemptions:', error);
    }
  };

  // Load referral data
  const loadReferralData = async () => {
    if (!UserID) return;

    setReferralLoading(true);
    try {
      // Get referral code from localStorage (set by backend)
      const storedReferralCode = localStorage.getItem('ReferralCode');

      // Construct referral URL using the stored code
      const referralUrl = storedReferralCode
        ? `${window.location.origin}/register?ref=${storedReferralCode}`
        : '';

      // Set basic referral data first
      setReferralData({
        referralCode: storedReferralCode || '',
        referralUrl: referralUrl,
        totalReferrals: 0,
        successfulReferrals: 0,
        pendingReferrals: 0,
        totalCredits: 0,
        availableCredits: 0
      });

      // Try to get referral stats and credits from API (optional)
      try {
        console.log('=== Frontend Referral Stats Debug ===');
        console.log('Calling referral stats API for UserID:', UserID);

        const statsResponse = await featureLimitsAPI.getReferralStats(UserID);
        console.log('Referral stats API response:', statsResponse);

        setReferralData(prev => ({
          ...prev,
          ...statsResponse
        }));
      } catch (statsError) {
        console.warn('Could not load referral stats:', statsError);
        // Keep the basic data we already set
      }
    } catch (error) {
      console.error('Error loading referral data:', error);
    } finally {
      setReferralLoading(false);
    }
  };

  // Load today's posts
  const loadTodaysPosts = async () => {
    if (!UserID) return;

    setPostsLoading(true);
    try {
      // Get user's timezone and today's date
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; 
      const todayDate = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/todays-posts/${UserID}?timezone=${timezone}&date=${todayDate}`);

      let posts = response.data || [];
      
      // Sort posts by status (pending, approved, posted) and then by time ascending
      posts.sort((a, b) => {
        // Helper function to get status priority (lower = higher priority)
        const getStatusPriority = (post) => {
          const status = (post.Status || '').toString().toUpperCase();
          if (status === 'PENDING') return 1;
          if (status === 'APPROVED') return 2;
          if (status === 'POSTED') return 3;
          return 4; // Unknown status at the end
        };

        // Helper function to parse time from ScheduledTimeAsPerZone or FormattedTime
        const parseTime = (post) => {
          // Try ScheduledTimeAsPerZone first
          if (post.ScheduledTimeAsPerZone) {
            const timeStr = post.ScheduledTimeAsPerZone.toString();
            const timeMatch = timeStr.match(/(\d{2}):(\d{2})/);
            if (timeMatch) {
              const hours = parseInt(timeMatch[1], 10);
              const minutes = parseInt(timeMatch[2], 10);
              return hours * 60 + minutes;
            }
          }
          
          // Try FormattedTime if available
          if (post.FormattedTime) {
            const timeStr = post.FormattedTime.toString();
            const timeMatch = timeStr.match(/(\d{2}):(\d{2})/);
            if (timeMatch) {
              const hours = parseInt(timeMatch[1], 10);
              const minutes = parseInt(timeMatch[2], 10);
              return hours * 60 + minutes;
            }
          }
          
          // Try ScheduleTime if available
          if (post.ScheduleTime) {
            const scheduleTime = new Date(post.ScheduleTime);
            if (!isNaN(scheduleTime.getTime())) {
              return scheduleTime.getHours() * 60 + scheduleTime.getMinutes();
            }
          }
          
          // Try to extract time from ScheduledPostDate
          if (post.ScheduledPostDate) {
            const scheduledDate = new Date(post.ScheduledPostDate);
            if (!isNaN(scheduledDate.getTime())) {
              return scheduledDate.getHours() * 60 + scheduledDate.getMinutes();
            }
          }
          
          return -1; // Return -1 for posts without time
        };
        
        // First, sort by status priority
        const statusA = getStatusPriority(a);
        const statusB = getStatusPriority(b);
        if (statusA !== statusB) {
          return statusA - statusB; // Lower priority number comes first
        }
        
        // Then sort by time ascending (earliest time first)
        const timeA = parseTime(a);
        const timeB = parseTime(b);
        
        if (timeA >= 0 && timeB >= 0) {
          if (timeA !== timeB) {
            return timeA - timeB; // Ascending order
          }
        } else if (timeA >= 0 && timeB < 0) {
          return -1; // A has time, B doesn't - A comes first
        } else if (timeA < 0 && timeB >= 0) {
          return 1; // B has time, A doesn't - B comes first
        }
        
        // If times are equal or both missing, fall back to date comparison (ascending)
        const dateA = a.ScheduledPostDate || a.CreatedDate || new Date(0);
        const dateB = b.ScheduledPostDate || b.CreatedDate || new Date(0);
        return new Date(dateA) - new Date(dateB);
      });
      
      setTodaysPosts(posts);
    } catch (error) {
      console.error('Error loading today\'s posts:', error);
      setTodaysPosts([]);
      // Show a subtle error message
      if (error.response?.status !== 404) {
        Swal.fire({
          icon: 'warning',
          title: 'Unable to load posts',
          text: 'There was an issue loading today\'s posts. Please try refreshing.',
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          position: 'top-end'
        });
      }
    } finally {
      setPostsLoading(false);
    }
  };

  // Load top-performing posts
  const loadTopPerformingPosts = async () => {
    if (!UserID) return;

    setTopPostsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/top-performing-posts/${UserID}`);
      const posts = response.data || [];
      
      // Backend already fetches real-time metrics from LinkedIn API, so we can use the data directly
      setTopPerformingPosts(posts);
    } catch (error) {
      console.error('Error loading top-performing posts:', error);
      setTopPerformingPosts([]);
      // Show a subtle error message
      if (error.response?.status !== 404) {
        Swal.fire({
          icon: 'warning',
          title: 'Unable to load top posts',
          text: 'There was an issue loading top-performing posts. Please try refreshing.',
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          position: 'top-end'
        });
      }
    } finally {
      setTopPostsLoading(false);
    }
  };

  // Check if post is expired
  const isPostExpired = (post) => {
    if (!post?.ScheduledPostDate || !post?.ScheduledTimeAsPerZone) return false;

    // Extract just the time part, ignoring the timezone (Z)
    const timePart = post.ScheduledTimeAsPerZone.split("T")[1].replace('Z', '');

    // Combine with date (ignore the time in ScheduledPostDate)
    const combinedDateTimeStr = `${post.ScheduledPostDate.split("T")[0]}T${timePart}`;

    // Force parse in the post's timezone
    const scheduledDateTime = moment.tz(combinedDateTimeStr, 'YYYY-MM-DDTHH:mm:ss', post.TimeZone);

    const now = moment().tz(post.TimeZone);

    return scheduledDateTime.isBefore(now);
  };

  const formatScheduledTime = (value) => (value ? String(moment.parseZone(value, moment.ISO_8601, true).isValid() ? moment.parseZone(value, moment.ISO_8601, true).format('hh:mm A') : moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm', true).format('hh:mm A') : value).replace(' ', '\u00a0') : '');
  // Load pending posts
  const loadPendingPosts = async () => {
    if (!UserID) return;

    setPendingPostsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallaigeneratedpostsbyUserID/${UserID}`);

      // Filter for pending posts only, exclude expired posts, and only get posts >= today's date
      const today = moment().startOf('day');
      const pendingPosts = response.data.filter(post => post.Status === 'PENDING' && !isPostExpired(post) && (!post.ScheduledPostDate || moment(post.ScheduledPostDate).startOf('day').isSameOrAfter(today)));
      
      // Sort by ScheduledPostDate in ascending order (oldest first)
      const sortedPending = pendingPosts.sort((a, b) => {
        const dateA = a.ScheduledPostDate ? new Date(a.ScheduledPostDate).getTime() : 0;
        const dateB = b.ScheduledPostDate ? new Date(b.ScheduledPostDate).getTime() : 0;
        return dateA - dateB; // Ascending order (oldest first)
      });
      
      console.log('Filtered pending posts:', sortedPending.length);
      setPendingPosts(sortedPending || []);
    } catch (error) {
      console.error('Error loading pending posts:', error);
      console.error('Error details:', error.response?.data);

      

      // Show a subtle error message
      if (error.response?.status !== 404) {
        Swal.fire({
          icon: 'warning',
          title: 'Unable to load pending posts',
          text: 'There was an issue loading pending posts. Please try refreshing.',
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          position: 'top-end'
        });
      }
    } finally {
      setPendingPostsLoading(false);
    }
  };

  // Load approved posts
  const loadApprovedPosts = async () => {
    if (!UserID) return;

    setApprovedPostsLoading(true);
    try {
      // Use optimized endpoint that filters and sorts at database level
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/approved-posts/${UserID}`);
      const posts = response.data || [];
      
      // Posts are already filtered and sorted by the stored procedure
      setApprovedPosts(posts);
    } catch (error) {
      console.error('Error loading approved posts:', error);
      setApprovedPosts([]);
    } finally {
      setApprovedPostsLoading(false);
    }
  };

  // Load KnackFeeds
  const loadKnackFeeds = async () => {
    if (!UserID) return;

    setKnackFeedsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/knackfeeds/${UserID}`);
      console.log('KnackFeeds API response:', response.data);
      console.log('KnackFeeds data structure:', response.data?.data);
      if (response.data?.data && response.data.data.length > 0) {
        console.log('First KnackFeed item fields:', Object.keys(response.data.data[0]));
        console.log('First KnackFeed item:', response.data.data[0]);
      }
      setKnackFeeds(response.data?.data || []);
    } catch (error) {
      console.error('Error loading KnackFeeds:', error);
      setKnackFeeds([]);
      // Show a subtle error message
      if (error.response?.status !== 404) {
        Swal.fire({
          icon: 'warning',
          title: 'Unable to load feeds',
          text: 'There was an issue loading the latest feeds. Please try refreshing.',
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          position: 'top-end'
        });
      }
    } finally {
      setKnackFeedsLoading(false);
    }
  };

  // Check if challenge is completed
  const isChallengeCompleted = (challenge) => {
    if (!challenge?.EndDate) return false;
    // Compare dates at start of day - hide only if EndDate is before today
    // Challenges ending today should still be shown
    const endDate = moment(challenge.EndDate).startOf('day');
    const today = moment().startOf('day');
    return endDate.isBefore(today);
  };

  // Load KnackChallenges
  const loadKnackChallenges = async () => {
    if (!UserID) return;

    setChallengesLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallchallenges?UserID=${UserID}`);
      console.log('KnackChallenges API response:', response.data);
      // Filter out completed challenges
      const activeChallenges = (response.data || []).filter(challenge => !isChallengeCompleted(challenge));
      setKnackChallenges(activeChallenges);
    } catch (error) {
      console.error('Error loading KnackChallenges:', error);
      setKnackChallenges([]);
      // Show a subtle error message
      if (error.response?.status !== 404) {
        Swal.fire({
          icon: 'warning',
          title: 'Unable to load challenges',
          text: 'There was an issue loading challenges. Please try refreshing.',
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          position: 'top-end'
        });
      }
    } finally {
      setChallengesLoading(false);
    }
  };

  const getMomentTimestamp = (momentItem = {}) => {
    const candidates = [
      momentItem.PostScheduledTime,
      momentItem.ScheduledTime,
      momentItem.CreatedDate,
      momentItem.CreatedOn,
      momentItem.CreatedAt,
      momentItem.created_at,
      momentItem.PostedOn
    ];

    for (const value of candidates) {
      if (!value) continue;
      const parsed = Date.parse(value);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return 0;
  };

  // Load Knack Moments
  const loadKnackMoments = async () => {
    if (!UserID) return;
    setKnackMomentsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallaigeneratedpostsbyUserID/${UserID}`);
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);

      const moments = (response.data || []).filter(post => post.PromptType === 2);
      const upcomingMoments = moments.filter(momentItem => getMomentTimestamp(momentItem) >= todayStart.getTime());
      const sortedMoments = [...upcomingMoments].sort((a, b) => getMomentTimestamp(a) - getMomentTimestamp(b));
      setKnackMoments(sortedMoments);
    } catch (error) {
      console.error('Error loading knack moments:', error);
      setKnackMoments([]);
    } finally {
      setKnackMomentsLoading(false);
    }
  };

  const handleViewMoment = (momentItem) => {
    if (momentItem.InterestsPromptID) {
      navigate(`/viewlatesttrendingpost/${momentItem.ContentID || momentItem.ContentId}`);
    } else {
      navigate(`/viewPostedAigeneratedschedulepost/${momentItem.ContentId || momentItem.ContentID || momentItem.PostId}`);
    }
  };

  // Load usage limits using existing API
  const loadUsageLimits = async () => {
    if (!UserID) return;

    setUsageLimitsLoading(true);
    try {
      // Get user's timezone and send it with the request
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/user-limits/${UserID}`, {
        params: {
          timezone: timezone
        }
      });
      console.log('Usage limits API response:', response.data);

      // Transform the response to match our state structure
      // The API returns an array of limit objects, we need to transform it
      const limitsData = response.data || [];
      const limits = {
        knack_feeds: { used: 0, limit: 1 },
        manual_posts: { used: 0, limit: 1 },
        schedule_days: { used: 0, limit: 7 }
      };

      // Process the response data to extract usage and limits
      limitsData.forEach(limit => {
        if (limit.feature_name === 'knack_feeds') {
          limits.knack_feeds = {
            used: limit.current_usage || 0,
            limit: limit.limit_value || 1
          };
        } else if (limit.feature_name === 'manual_posts') {
          limits.manual_posts = {
            used: limit.current_usage || 0,
            limit: limit.limit_value || 1
          };
        } else if (limit.feature_name === 'schedule_days') {
          limits.schedule_days = {
            used: limit.current_usage || 0,
            limit: limit.limit_value || 7
          };
        }
      });

      setUsageLimits(limits);
    } catch (error) {
      console.error('Error loading usage limits:', error);
      // Keep default values on error
      setUsageLimits({
        knack_feeds: { used: 0, limit: 10 },
        manual_posts: { used: 0, limit: 20 },
        schedule_days: { used: 0, limit: 30 }
      });
    } finally {
      setUsageLimitsLoading(false);
    }
  };

  // Get user profile data from localStorage
  const loginname = JSON.parse(localStorage.getItem("userProfile"));
  const profileDet = loginname ? loginname[0] : null;

  // Handle LinkedIn login
  const handleLinkedInLogin = () => {
    if (!loginType) {
      Swal.fire({
        icon: 'warning',
        title: 'Account Type Required',
        text: 'Please select an account type before login with LinkedIn'
      });
      return;
    }



    console.log(loginType);
    const linkedinAuthorizeUrl = `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/authorize?UserID=${UserID}&loginType=${loginType}&scopes=${selectedScopes.join(' ')}`;
    window.location.href = linkedinAuthorizeUrl;
  };

  // const handleShareUrl = () => {
  //   const currentUrl = window.location.href;
  //   navigator.clipboard.writeText(currentUrl)
  //     .then(() => {
  //       alert('URL copied to clipboard. Share it via WhatsApp or other platforms.');
  //     })
  //     .catch(err => {
  //       console.error('Failed to copy URL:', err);
  //     });
  // };

  const handleShareUrl = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl)
      .then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Link Copied!!',
          showConfirmButton: false,
          timer: 3000

        });
      })
      .catch(err => {
        console.error('Failed to copy URL:', err);
        Swal.fire({
          title: 'Error',
          text: 'Failed to copy the URL. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      });
  };

  // Copy referral code to clipboard
  const copyReferralCode = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Referral Code Copied!',
        showConfirmButton: false,
        timer: 2000
      });
    } catch (error) {
      console.error('Failed to copy:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to copy referral code. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  // Copy referral code with explanatory message
  const copyReferralCodeWithMessage = async (url) => {
    const message = `Hey! I'd love for you to join me on KnackVibes! 

Please click the below link to sign up and start creating amazing content:

${url}

You'll get access to powerful AI tools for content creation! 🎉`;

    try {
      await navigator.clipboard.writeText(message);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Link Copied!',
        text: 'Ready to share with your friends!',
        showConfirmButton: false,
        timer: 3000
      });
    } catch (error) {
      console.error('Failed to copy referral message:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to copy message. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  // Open Gmail directly in browser
  const openGmail = (url) => {
    const subject = 'Join me on KnackVibes!';

    // Create message with HTML formatting for better link detection
    const message = `Hey! I'd love for you to join me on KnackVibes!

Please click the below link to sign up and start creating amazing content:

${url}

You'll get access to powerful AI tools for content creation, and I'll earn some credits too! 🎉`;

    // Encode the message
    const body = encodeURIComponent(message);

    // Create Gmail compose URL with rich text formatting enabled
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&ui=2&tf=1&to=&su=${encodeURIComponent(subject)}&body=${body}`;

    // Open Gmail in a new tab
    window.open(gmailUrl, '_blank');

    // Show a helpful message
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Gmail Opened!',
      text: 'Gmail should open with rich text formatting. The URL should be automatically clickable.',
      showConfirmButton: false,
      timer: 3000
    });
  };

  // Open email client with referral message
  const openEmailClient = (url) => {
    const message = `Hey! I'd love for you to join me on KnackVibes! 

Please click the below link to sign up and start creating amazing content:

${url}

You'll get access to powerful AI tools for content creation, and I'll earn some credits too! 🎉`;

    const subject = 'Join me on KnackVibes!';
    const body = encodeURIComponent(message);
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${body}`;

    // Try to open the email client
    window.location.href = mailtoLink;

    // Show a helpful message
    Swal.fire({
      position: 'center',
      icon: 'info',
      title: 'Email Client Opened!',
      text: 'If your email client didn\'t open, try the "Copy Message" button instead.',
      showConfirmButton: false,
      timer: 3000
    });
  };

  // Share referral link
  const shareReferralLink = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Join KnackVibes with my referral!',
        text: 'Get started with KnackVibes and unlock amazing features!',
        url: referralData.referralUrl
      });
    } else {
      copyReferralCode(referralData.referralUrl);
    }
  };



  const homeWelcomeBanner = (
    <div className="welcome-banner-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: 0, position: 'relative' }}>
                {/* Desktop Layout */}
                <div className="d-flex align-items-center welcome-banner-left">
                  <div className="me-3">
                    <div
                      className="rounded-circle"
                      style={{
                        width: '48px',
                        height: '48px',
                        border: '2px solid rgba(255,255,255,0.3)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        position: 'relative'
                      }}
                    >
                      <img
                        src={userProfile && userProfile.length > 0 && userProfile[0]?.ProfileUrl ? userProfile[0].ProfileUrl : defaultimage}
                        alt="Profile"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                        onError={(e) => {
                          e.target.src = defaultimage;
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <h4 className="mb-0 fw-bold text-white" style={{
                      fontSize: '1.1rem',
                      letterSpacing: '-0.3px',
                      lineHeight: '1.2'
                    }}>
                      Welcome, {userProfile && userProfile.length > 0 ?
                        (userProfile[0]?.OrganizationName || userProfile[0]?.FullName) :
                        'User'
                      }
                    </h4>
                    <div className="d-flex align-items-center mt-1">
                      {localStorage.getItem('subscriptionEndDate') && localStorage.getItem('subscriptionEndDate') !== 'null' ? (
                        <>
                          <span className="badge bg-white me-2 px-2 py-1" style={{
                            fontSize: '10px',
                            fontWeight: '600',
                            color: '#2e3192',
                            borderRadius: '12px'
                          }}>
                            ✨ Premium
                          </span>
                          <small className="text-white" style={{ fontSize: '11px', opacity: 0.9 }}>
                            Active subscription
                          </small>
                        </>
                      ) : (
                        <>
                          <span className="badge bg-warning me-2 px-2 py-1" style={{
                            fontSize: '10px',
                            fontWeight: '600',
                            color: '#000',
                            borderRadius: '12px'
                          }}>
                            Free Trial
                          </span>
                          <small className="text-white" style={{ fontSize: '11px', opacity: 0.9 }}>
                            Limited features
                          </small>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-2 align-items-center welcome-banner-right">
                      <button
                        className="btn btn-light"
                        onClick={() => navigate('/create-post')}
                        title="Create Post"
                        style={{
                          borderRadius: '8px',
                          width: '40px',
                          height: '40px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#2e3192',
                          border: 'none',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          fontSize: '16px',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-1px)';
                          e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                        }}
                      >
                        <FaPlus />
                      </button>
                      <div
                        onClick={handleLinkedInLogin}
                        title={Token == null ? 'Login with LinkedIn' : 'Login with another LinkedIn account'}
                        style={{
                          position: 'relative',
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          border: '1px solid rgba(255,255,255,0.3)',
                          backgroundColor: 'rgba(255,255,255,0.1)',
                          backdropFilter: 'blur(10px)',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {linkedInProfileUrl ? (
                          <>
                            <img
                              src={linkedInProfileUrl}
                              alt="LinkedIn"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '2px',
                                right: '2px',
                                width: '18px',
                                height: '18px',
                                borderRadius: '50%',
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px solid white',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                zIndex: 10
                              }}
                            >
                              <i className="fa fa-linkedin" style={{ fontSize: '12px', color: '#0077b5' }}></i>
                            </div>
                          </>
                        ) : (
                          <i className="fa fa-linkedin" style={{ fontSize: '16px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}></i>
                        )}
                      </div>
                </div>

                {/* Mobile Layout */}
                <div className="welcome-banner-mobile">
                  <div className="d-flex align-items-center justify-content-between" style={{ width: '100%', position: 'relative' }}>
                    {/* Profile and Name - Left side, moved closer to chevron */}
                    <div className="d-flex align-items-center" style={{ flex: 1, minWidth: 0, gap: '10px' }}>
                      <div style={{ flexShrink: 0 }}>
                        <div
                          className="rounded-circle"
                          style={{
                            width: '56px',
                            height: '56px',
                            border: '2px solid rgba(255,255,255,0.3)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            position: 'relative'
                          }}
                        >
                          <img
                            src={userProfile && userProfile.length > 0 && userProfile[0]?.ProfileUrl ? userProfile[0].ProfileUrl : defaultimage}
                            alt="Profile"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                            onError={(e) => {
                              e.target.src = defaultimage;
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 'calc(100vw - 200px)' }}>
                        <h4 className="mb-0 fw-bold text-white welcome-name-mobile" style={{
                          fontSize: '1rem',
                          letterSpacing: '-0.3px',
                          lineHeight: '1.3',
                          marginBottom: '3px',
                          wordBreak: 'break-word'
                        }}>
                          Welcome, {userProfile && userProfile.length > 0 ?
                            (userProfile[0]?.OrganizationName || userProfile[0]?.FullName) :
                            'User'
                          }
                        </h4>
                        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                          {localStorage.getItem('subscriptionEndDate') && localStorage.getItem('subscriptionEndDate') !== 'null' ? (
                            <>
                              <span className="badge bg-white px-2 py-1" style={{
                                fontSize: '10px',
                                fontWeight: '600',
                                color: '#2e3192',
                                borderRadius: '12px',
                                whiteSpace: 'nowrap',
                                lineHeight: '1.2'
                              }}>
                                ✨ Premium
                              </span>
                              <small className="text-white" style={{ fontSize: '10px', opacity: 0.9, whiteSpace: 'nowrap', lineHeight: '1.2' }}>
                                Active
                              </small>
                            </>
                          ) : (
                            <>
                              <span className="badge bg-warning px-2 py-1" style={{
                                fontSize: '10px',
                                fontWeight: '600',
                                color: '#000',
                                borderRadius: '12px',
                                whiteSpace: 'nowrap',
                                lineHeight: '1.2'
                              }}>
                                Free Trial
                              </span>
                              <small className="text-white" style={{ fontSize: '10px', opacity: 0.9, whiteSpace: 'nowrap', lineHeight: '1.2' }}>
                                Limited
                              </small>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* Action Buttons - Right side, horizontally arranged */}
                    <div className="d-flex gap-2 align-items-center" style={{ flexShrink: 0, marginRight: '12px' }}>
                      <button
                        className="btn btn-light"
                        onClick={() => navigate('/create-post')}
                        title="Create Post"
                        style={{
                          borderRadius: '8px',
                          width: '36px',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#2e3192',
                          border: 'none',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          fontSize: '14px',
                          transition: 'all 0.2s ease',
                          padding: 0
                        }}
                      >
                        <FaPlus />
                      </button>
                      <div
                        onClick={handleLinkedInLogin}
                        title={Token == null ? 'Login with LinkedIn' : 'Login with another LinkedIn account'}
                        style={{
                          position: 'relative',
                          width: '36px',
                          height: '36px',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          border: '1px solid rgba(255,255,255,0.3)',
                          backgroundColor: 'rgba(255,255,255,0.1)',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          flexShrink: 0
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        {linkedInProfileUrl ? (
                          <>
                            <img
                              src={linkedInProfileUrl}
                              alt="LinkedIn"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '2px',
                                right: '2px',
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '1.5px solid white',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                zIndex: 10
                              }}
                            >
                              <i className="fa fa-linkedin" style={{ fontSize: '10px', color: '#0077b5' }}></i>
                            </div>
                          </>
                        ) : (
                          <i className="fa fa-linkedin" style={{ fontSize: '14px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}></i>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
    </div>
  );

  return (
    <>
      <SideNavbar headerRight={homeWelcomeBanner}>
        {/* Unified Welcome & Membership Card moved to headerRight */}

        {/* Accordion Referral Section - Below Welcome Banner */}
        {!referralLoading && localStorage.getItem('ReferralCode') && (
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm" style={{
                borderRadius: '8px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                overflow: 'hidden'
              }}>
                {/* Accordion Header */}
                <div
                  className="card-header bg-white border-bottom p-3"
                  style={{
                    cursor: 'pointer',
                    borderRadius: isReferralAccordionOpen ? '8px 8px 0 0' : '8px',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => setIsReferralAccordionOpen(!isReferralAccordionOpen)}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <FaGift className="me-2 text-warning" size={16} />
                      <div>
                        <h6 className="mb-0 fw-bold" style={{
                          fontSize: '14px',
                          color: '#2e3192'
                        }}>
                          Referral Code
                        </h6>
                        <small className="text-muted" style={{ fontSize: '10px' }}>
                          Share & earn credits
                        </small>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                      {/* Stats */}
                      <div className="d-flex gap-3">
                        <div className="text-center">
                          <div style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#2e3192',
                            lineHeight: '1'
                          }}>
                            {referralData.totalReferrals || 0}
                          </div>
                          <small className="text-muted" style={{ fontSize: '8px' }}>
                            Referrals
                          </small>
                        </div>
                        <div className="text-center">
                          <div style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#28a745',
                            lineHeight: '1'
                          }}>
                            {referralData.availableCredits || 0}
                          </div>
                          <small className="text-muted" style={{ fontSize: '8px' }}>
                            Credits
                          </small>
                        </div>
                      </div>

                      {/* Expand/Collapse Icon */}
                      <div
                        style={{
                          transform: isReferralAccordionOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease',
                          fontSize: '12px',
                          color: '#2e3192'
                        }}
                      >
                        <i className="fa fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accordion Body */}
                <div
                  style={{
                    maxHeight: isReferralAccordionOpen ? '500px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease, padding 0.3s ease',
                    padding: isReferralAccordionOpen ? '16px' : '0',
                    margin: 0
                  }}
                >
                  {isReferralAccordionOpen && (
                    <div style={{ animation: 'fadeIn 0.3s ease' }}>
                      <div className="row align-items-center">
                        {/* Center: Referral Link */}
                        <div className="col-lg-8 col-md-12 mb-3 mb-lg-0">
                          <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Form.Control
                              type="text"
                              value={referralData.referralUrl || 'Loading...'}
                              readOnly
                              style={{
                                fontFamily: 'monospace',
                                fontSize: '11px',
                                height: '32px',
                                border: '1px solid #ced4da',
                                borderRadius: '6px 0 0 6px',
                                backgroundColor: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            />
                            <button
                              className="btn btn-outline-primary"
                              onClick={() => {
                                if (referralData.referralUrl) {
                                  copyReferralCode(referralData.referralUrl);
                                }
                              }}
                              style={{
                                height: '32px',
                                padding: '0 8px',
                                borderRadius: '0 6px 6px 0',
                                fontSize: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                              title="Copy referral link"
                            >
                              <FaCopy size={10} />
                            </button>
                          </div>
                        </div>

                        {/* Right: Actions */}
                        <div className="col-lg-4 col-md-12">
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                if (referralData.referralUrl) {
                                  copyReferralCodeWithMessage(referralData.referralUrl);
                                }
                              }}
                              style={{
                                fontSize: '10px',
                                padding: '4px 8px',
                                borderRadius: '4px'
                              }}
                              title="Copy link"
                            >
                              Copy
                            </button>
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => {
                                if (referralData.referralUrl) {
                                  openGmail(referralData.referralUrl);
                                }
                              }}
                              style={{
                                fontSize: '10px',
                                padding: '4px 8px',
                                borderRadius: '4px'
                              }}
                              title="Share via email"
                            >
                              <FaShare size={8} />
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Bottom Banner */}
                      <div className="mt-3 text-center">
                        <div className="alert alert-info mb-0 py-1" style={{
                          fontSize: '9px',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          backgroundColor: '#e3f2fd',
                          border: '1px solid #bbdefb',
                          color: '#1976d2',
                          margin: 0
                        }}>
                          💰 Earn 2 credits per referral • Reach 10 credits for 30 days free!
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        <div><SubscriptionStatus /></div>

        {loading ? <div className='spinner'></div> : (
          <>

            {/* Dashboard Cards Section - 2 per row */}
            <div className="row mb-3">
              {/* Today's Posts Card */}
              <div className="col-lg-6 col-md-12 mb-2">
                <div className="card border-0 shadow-sm h-100" style={{
                  borderRadius: '12px'
                }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          background: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #e9ecef'
                        }}>
                          <FaChartLine size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <div className="d-flex align-items-center mb-1">
                          <h6 className="mb-0 fw-bold me-2" style={{
                            fontSize: '1.1rem',
                            color: '#2e3192'
                          }}>
                            Today's Posts
                          </h6>
                          {!postsLoading && (
                            <span className="badge bg-light text-dark" style={{ fontSize: '12px', fontWeight: '600' }}>
                              {todaysPosts.length}
                            </span>
                          )}
                        </div>
                        <small className="text-muted">Your recent content activity</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={loadTodaysPosts}
                        disabled={postsLoading}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px'
                        }}
                        title="Refresh today's posts"
                      >
                        <FaSync size={10} />
                      </button>
                      {postsLoading && (
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => navigate('/todays-posts')}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px',
                          backgroundColor: '#fff',
                          color: '#2e3192',
                          border: '1px solid #fff',
                          fontWeight: '600'
                        }}
                      >
                        More
                      </button>
                    </div>
                  </div>
                  <div className="card-body" style={{
                    maxHeight: '300px',
                    overflowY: 'auto'
                  }}>
                    {postsLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading posts...</span>
                        </div>
                        <p className="mt-2 text-muted small">Loading today's posts...</p>
                      </div>
                    ) : todaysPosts.length > 0 ? (
                      <div className="row">
                        {todaysPosts.slice(0, 3).map((post, index) => (
                          <div key={`todays-post-${post.ContentId}-${index}`} className="col-md-4 mb-3">
                            <div 
                              className="card border-0 shadow-sm h-100" 
                              style={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                padding: '12px',
                                height: '180px',
                                display: 'flex',
                                flexDirection: 'column',
                                cursor: 'pointer',
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                              }}
                              onClick={() => {
                                console.log('Today Post Clicked:', post.ContentId);
                                if (post.ContentId) {
                                  // Check if this is a challenge post
                                  if (post.PostType === 'challenge') {
                                    navigate('/KnackChallenges');
                                    return;
                                  }
                                  
                                  // Check if this is a KnackFeed (has InterestsPromptID or PostSource is 'knackfeed')
                                  const isKnackFeed = post.InterestsPromptID || post.PostType === 'knack_feed' || post.PostSource === 'knackfeed';
                                  const contentId = post.ContentId || post.ContentID;
                                  
                                  if (isKnackFeed && contentId) {
                                    const status = (post.Status || '').toString().toUpperCase();
                                    // If posted, navigate to view page; otherwise navigate to update page
                                    if (status === 'POSTED' || (status === 'APPROVED' && post.LinkdinPostId && post.LinkdinPostId.trim() !== '')) {
                                      navigate(`/viewPostedAigeneratedschedulepost/${contentId}`);
                                    } else {
                                      // Navigate to KnackFeed update page
                                      navigate(`/updatelatesttrendingnews/${contentId}`);
                                    }
                                  } else {
                                    const status = (post.Status || '').toString().toUpperCase();
                                    // POSTED status or APPROVED with LinkdinPostId should go to view page
                                    if (status === 'POSTED' || (status === 'APPROVED' && post.LinkdinPostId && post.LinkdinPostId.trim() !== '')) {
                                      // Navigate to view page for posted posts
                                      navigate(`/viewPostedAigeneratedschedulepost/${post.ContentId}`);
                                    } else {
                                      // Navigate to edit page for pending/approved posts (not yet posted)
                                      navigate(`/updatependingpost/${post.ContentId}`);
                                    }
                                  }
                                } else {
                                  console.error('ContentId is missing');
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                              }}
                            >
                              {/* Image/Poll Section */}
                              <div style={{ flex: '0 0 auto' }}>
                                {(() => {
                                  // Check if this is a poll
                                  // pollrequired can be true, 1, or boolean true
                                  const pollRequired = post.pollrequired === true || post.pollrequired === 1 || post.pollrequired === 'true' || post.pollrequired === '1';
                                  const hasQuestionOptions = post.QuestionwithOptions && 
                                    (typeof post.QuestionwithOptions === 'string' ? post.QuestionwithOptions.trim() !== '' : post.QuestionwithOptions);
                                  const isPoll = pollRequired || hasQuestionOptions;
                                  
                                  let pollData = null;
                                  if (isPoll && post.QuestionwithOptions) {
                                    try {
                                      pollData = typeof post.QuestionwithOptions === 'string' 
                                        ? JSON.parse(post.QuestionwithOptions) 
                                        : post.QuestionwithOptions;
                                    } catch (e) {
                                      console.error('Error parsing poll data:', e);
                                    }
                                  }
                                  
                                  if (isPoll && pollData) {
                                    // Show "No image" placeholder for polls (same as regular posts)
                                    return (
                                      <div className="mb-2">
                                        <div
                                          className="d-flex flex-column align-items-center justify-content-center"
                                          style={{
                                            width: '100%',
                                            height: '60px',
                                            backgroundColor: '#e3f2fd',
                                            border: '2px solid #2196f3',
                                            borderRadius: '6px'
                                          }}
                                        >
                                          <FaFileAlt size={16} className="text-primary mb-1" />
                                          <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>
                                            No image
                                          </small>
                                        </div>
                                      </div>
                                    );
                                  } else if ((post.PostImage || post.Image || post.image || post.ImageURL) && (post.PostImage || post.Image || post.image || post.ImageURL) !== '/assets/default-post-image.png') {
                                    const mediaPath = post.PostImage || post.Image || post.image || post.ImageURL;
                                    const mediaUrl = getMediaUrl(mediaPath);
                                    const isVideo = isVideoFile(mediaPath);
                                    
                                    if (isVideo && mediaUrl) {
                                      // Show video if available
                                      return (
                                        <div className="mb-2">
                                          <video
                                            src={mediaUrl}
                                            controls
                                            style={{
                                              width: '100%',
                                              height: '60px',
                                              objectFit: 'cover',
                                              borderRadius: '6px'
                                            }}
                                          >
                                            Your browser does not support the video tag.
                                          </video>
                                        </div>
                                      );
                                    } else if (mediaUrl) {
                                    // Show image if available
                                    return (
                                      <div className="mb-2">
                                        <img
                                            src={mediaUrl}
                                          alt={post.ShortContent || 'Post Image'}
                                          style={{
                                            width: '100%',
                                            height: '60px',
                                            objectFit: 'cover',
                                            borderRadius: '6px'
                                          }}
                                          onError={(e) => {
                                            e.target.style.display = 'none';
                                          }}
                                        />
                                      </div>
                                    );
                                    }
                                  } else {
                                    // Show "No image" placeholder
                                    return (
                                      <div className="mb-2">
                                        <div
                                          className="d-flex flex-column align-items-center justify-content-center"
                                          style={{
                                            width: '100%',
                                            height: '60px',
                                            backgroundColor: '#e3f2fd',
                                            border: '2px solid #2196f3',
                                            borderRadius: '6px'
                                          }}
                                        >
                                          <FaFileAlt size={16} className="text-primary mb-1" />
                                          <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>
                                            No image
                                          </small>
                                        </div>
                                      </div>
                                    );
                                  }
                                })()}
                              </div>

                              {/* Content Section */}
                              <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div>
                                  <div className="small fw-bold" style={{
                                    fontSize: '12px',
                                    color: '#2e3192',
                                    marginBottom: '4px',
                                    lineHeight: '1.3',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical'
                                  }}>
                                    {(() => {
                                      // Check if this is a poll
                                      const pollRequired = post.pollrequired === true || post.pollrequired === 1 || post.pollrequired === 'true' || post.pollrequired === '1';
                                      const hasQuestionOptions = post.QuestionwithOptions && 
                                        (typeof post.QuestionwithOptions === 'string' ? post.QuestionwithOptions.trim() !== '' : post.QuestionwithOptions);
                                      const isPoll = pollRequired || post.QuestionwithOptions !== null ;
                                  
                                      if (pollRequired) {
                                        // Show "Poll" as title
                                        return 'Poll';
                                      }
                                      return post.ShortContent || 'AI Generated Content';
                                    })()}
                                  </div>
                                  
                                  {/* Show poll question below Poll title for polls */}
                                  {(() => {
                                    const pollRequired = post.pollrequired === true || post.pollrequired === 1 || post.pollrequired === 'true' || post.pollrequired === '1';
                                    const hasQuestionOptions = post.QuestionwithOptions && 
                                      (typeof post.QuestionwithOptions === 'string' ? post.QuestionwithOptions.trim() !== '' : post.QuestionwithOptions);
                                    const isPoll = pollRequired || hasQuestionOptions;
                                    
                                    if (isPoll && post.QuestionwithOptions) {
                                      let pollData = null;
                                      try {
                                        pollData = typeof post.QuestionwithOptions === 'string' 
                                          ? JSON.parse(post.QuestionwithOptions) 
                                          : post.QuestionwithOptions;
                                      } catch (e) {
                                        console.error('Error parsing poll data:', e);
                                      }
                                      
                                      if (pollData && pollData.question) {
                                        return (
                                          <div className="small text-muted mt-1" style={{
                                            fontSize: '11px',
                                            lineHeight: '1.3',
                                            overflow: 'hidden',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical'
                                          }}>
                                            {pollData.question}
                                          </div>
                                        );
                                      }
                                    }
                                    return null;
                                  })()}
                                  
                                  <div className="d-flex justify-content-between align-items-center mt-1" style={{ fontSize: '10px' }}>
                                    <small className="text-muted">
                                      {post.ScheduledTimeAsPerZone ?formatScheduledTime(post.ScheduledTimeAsPerZone) : (post.FormattedTime || 'Today')}
                                      {/* {post.ScheduledTimeAsPerZone ? (() => {
                                        // Format ScheduledTimeAsPerZone (e.g., "23:52:22.0000000" or "12:40:00")
                                        const timeStr = post.ScheduledTimeAsPerZone.toString();
                                        // Extract HH:MM from the time string
                                        const timeMatch = timeStr.match(/(\d{2}):(\d{2})/);
                                        if (timeMatch) {
                                          return `${timeMatch[1]}:${timeMatch[2]}`;
                                        }
                                        return timeStr;
                                      })() : (post.CreatedDate ? (() => {
                                        const date = new Date(post.CreatedDate);
                                        return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
                                      })() : (post.FormattedTime || 'Today'))} */}
                                    </small>
                                    {(() => {
                                      const raw = (post.Status || '').toString().toUpperCase();
                                      const hasLinkedin = !!(post.LinkdinPostId && post.LinkdinPostId.trim() !== '');
                                      const isKnackFeed = post.InterestsPromptID || post.PostType === 'knack_feed' || post.PostSource === 'knackfeed';
                                      
                                      // For KnackFeeds, treat PENDING and APPROVED as Approved
                                      if (isKnackFeed && (raw === 'PENDING' || raw === 'APPROVED')) {
                                        return (<FaCheckCircle size={12} style={{ color: '#0d6efd' }} title="Approved" />);
                                      }
                                      
                                      const isPosted = raw === 'POSTED' || (raw === 'APPROVED' && hasLinkedin);
                                      const isApproved = raw === 'APPROVED' && !hasLinkedin;
                                      const isPending = raw === 'PENDING';
                                      if (isPosted) return (<FaCheckCircle size={12} style={{ color: '#28a745' }} title="Posted" />);
                                      if (isApproved) return (<FaCheckCircle size={12} style={{ color: '#0d6efd' }} title="Approved" />);
                                      if (isPending) return (<FaClock size={12} style={{ color: '#ffc107' }} title="Pending" />);
                                      return (<FaClock size={12} style={{ color: '#6c757d' }} title={raw || 'Unknown'} />);
                                    })()}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <div className="text-muted">
                          <FaFileAlt size={32} className="mb-2" />
                          <p className="mb-0">No posts created today</p>
                          <small>Start creating content to see your posts here!</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Top-Performing Posts Card */}
              <div className="col-lg-6 col-md-12 mb-2">
                <div className="card border-0 shadow-sm h-100" style={{
                  borderRadius: '12px'
                }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          background: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #e9ecef'
                        }}>
                          <FaTrophy size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <div className="d-flex align-items-center mb-1">
                          <h6 className="mb-0 fw-bold me-2" style={{
                            fontSize: '1.1rem',
                            color: '#2e3192'
                          }}>
                            Top Performing Posts
                          </h6>
                          {!topPostsLoading && (
                            <span className="badge bg-light text-dark" style={{ fontSize: '12px', fontWeight: '600' }}>
                              {topPerformingPosts.length}
                            </span>
                          )}
                        </div>
                        <small className="text-muted">Your best performing content</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={loadTopPerformingPosts}
                        disabled={topPostsLoading}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px'
                        }}
                        title="Refresh top performing posts"
                      >
                        <FaSync size={10} />
                      </button>
                      {topPostsLoading && (
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => navigate('/topperformingposts')}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px',
                          backgroundColor: '#fff',
                          color: '#2e3192',
                          border: '1px solid #fff',
                          fontWeight: '600'
                        }}
                      >
                        More
                      </button>
                    </div>
                  </div>
                  <div className="card-body" style={{
                    padding: '16px'
                  }}>
                    {topPostsLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-success" role="status">
                          <span className="visually-hidden">Loading posts...</span>
                        </div>
                        <p className="mt-2 text-muted small">Loading top-performing posts...</p>
                      </div>
                    ) : topPerformingPosts.length > 0 ? (
                      <div className="row">
                        {topPerformingPosts.slice(0, 3).map((post, index) => (
                          <div key={`top-post-${post.ContentId}-${index}`} className="col-md-4 mb-3">
                            <div 
                              className="card border-0 shadow-sm h-100" 
                              style={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                padding: '12px',
                                height: '180px',
                                display: 'flex',
                                flexDirection: 'column',
                                cursor: 'pointer',
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                              }}
                              onClick={() => {
                                console.log('Top Performing Post Clicked:', post.ContentId);
                                if (post.LinkdinPostId || post.ContentId) {
                                  navigate(`/viewpostcomments/${post.LinkdinPostId || post.ContentId}`);
                                } else {
                                  console.error('LinkdinPostId or ContentId is missing');
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                              }}
                            >
                              {/* Image/Video Section */}
                              <div style={{ flex: '0 0 auto' }}>
                                {(() => {
                                  const mediaPath = post.PostImage || post.Image || post.image || post.ImageURL;
                                  if (mediaPath && mediaPath !== '/assets/default-post-image.png') {
                                    const mediaUrl = getMediaUrl(mediaPath);
                                    const isVideo = isVideoFile(mediaPath);
                                    
                                    if (isVideo && mediaUrl) {
                                      // Show video if available
                                      return (
                                        <div className="mb-2">
                                          <video
                                            src={mediaUrl}
                                            controls
                                            style={{
                                              width: '100%',
                                              height: '60px',
                                              objectFit: 'cover',
                                              borderRadius: '6px'
                                            }}
                                          >
                                            Your browser does not support the video tag.
                                          </video>
                                        </div>
                                      );
                                    } else if (mediaUrl) {
                                      // Show image if available
                                      return (
                                  <div className="mb-2">
                                    <img
                                            src={mediaUrl}
                                      alt={post.ShortContent || 'Top Post Image'}
                                      style={{
                                        width: '100%',
                                        height: '60px',
                                        objectFit: 'cover',
                                        borderRadius: '6px'
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                      }}
                                    />
                                  </div>
                                      );
                                    }
                                  }
                                  // Show placeholder if no media
                                  return (
                                  <div className="mb-2">
                                    <div
                                      className="d-flex flex-column align-items-center justify-content-center"
                                      style={{
                                        width: '100%',
                                        height: '60px',
                                        backgroundColor: '#e3f2fd',
                                        border: '2px solid #2196f3',
                                        borderRadius: '6px'
                                      }}
                                    >
                                      <FaFileAlt size={16} className="text-primary mb-1" />
                                      <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>
                                        No image
                                      </small>
                                    </div>
                                  </div>
                                  );
                                })()}
                              </div>

                              {/* Content Section */}
                              <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div>
                                  <div className="small fw-bold" style={{
                                    fontSize: '12px',
                                    color: '#2e3192',
                                    marginBottom: '4px',
                                    lineHeight: '1.3',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical'
                                  }}>
                                    {post.ShortContent || 'Top Performing Content'}
                                  </div>

                                  <div className="small text-muted d-flex justify-content-between" style={{
                                    fontSize: '10px',
                                    lineHeight: '1.2',
                                    marginTop: '4px'
                                  }}>
                                    <span>{post.LikeCount !== undefined && post.LikeCount !== null ? `${post.LikeCount.toLocaleString()} likes` : 'High engagement'}</span>
                                    <span>{post.CommentCount !== undefined && post.CommentCount !== null ? `${post.CommentCount} comments` : 'Top performer'}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <div className="text-muted">
                          <FaTrophy size={32} className="mb-2" />
                          <p className="mb-0">No top-performing posts yet</p>
                          <small>Create and post content to see performance metrics!</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Pending Posts and Approved Posts Row */}
            <div className="row mb-3">
              {/* Pending Posts Card */}
              <div className="col-lg-6 col-md-12 mb-2">
                <div className="card border-0 shadow-sm h-100" style={{
                  borderRadius: '12px'
                }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          background: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #e9ecef'
                        }}>
                          <FaBell size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <div className="d-flex align-items-center mb-1">
                          <h6 className="mb-0 fw-bold me-2" style={{
                            fontSize: '1.1rem',
                            color: '#2e3192'
                          }}>
                            Pending Posts
                          </h6>
                          {!pendingPostsLoading && (
                            <span className="badge bg-warning" style={{ fontSize: '12px', fontWeight: '600' }}>
                              {pendingPosts.length}
                            </span>
                          )}
                        </div>
                        <small className="text-muted">Awaiting your review</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={loadPendingPosts}
                        disabled={pendingPostsLoading}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px'
                        }}
                        title="Refresh pending posts"
                      >
                        <FaSync size={10} />
                      </button>
                      {pendingPostsLoading && (
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => navigate('/viewallpendingposts')}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px',
                          backgroundColor: '#fff',
                          color: '#2e3192',
                          border: '1px solid #fff',
                          fontWeight: '600'
                        }}
                      >
                        More
                      </button>
                    </div>
                  </div>
                  <div className="card-body" style={{
                    maxHeight: '300px',
                    overflowY: 'auto'
                  }}>
                    {pendingPostsLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-warning" role="status">
                          <span className="visually-hidden">Loading posts...</span>
                        </div>
                        <p className="mt-2 text-muted small">Loading pending posts...</p>
                      </div>
                    ) : pendingPosts.length > 0 ? (
                      <div className="row">
                        {pendingPosts.slice(0, 3).map((post, index) => {


                          // Get the content from the API response
                          let displayContent = post.Content || post.Prompts || 'AI Generated Content';

                          return (
                            <div key={`pending-post-${post.PostId}-${index}`} className="col-md-4 mb-3">
                              <div 
                                className="card border-0 shadow-sm" 
                                style={{
                                  backgroundColor: '#f8f9fa',
                                  borderRadius: '8px',
                                  padding: '12px',
                                  height: '180px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  cursor: 'pointer',
                                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                                }}
                                onClick={() => {
                                console.log('Top Post Clicked:', post.ContentId);
                                if (post.ContentId) {
                                  navigate(`/updatependingpost/${post.ContentId}`);
                                } else {
                                  console.error('ContentId is missing');
                                }
                              }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                }}
                              >
                                {/* Media Section for Pending Posts */}
                                <div className="mb-2">
                                  {(() => {
                                    const mediaPath = post.Image || post.PostImage || post.image || post.ImageURL;
                                    if (mediaPath && mediaPath !== '/assets/default-post-image.png' && mediaPath.trim() !== '') {
                                      const mediaUrl = getMediaUrl(mediaPath);
                                      const isVideo = isVideoFile(mediaPath);
                                      
                                      if (isVideo && mediaUrl) {
                                        // Show video if available
                                        return (
                                          <video
                                            src={mediaUrl}
                                            controls
                                            style={{
                                              width: '100%',
                                              height: '60px',
                                              objectFit: 'cover',
                                              borderRadius: '6px'
                                            }}
                                          >
                                            Your browser does not support the video tag.
                                          </video>
                                        );
                                      } else if (mediaUrl) {
                                        // Show image if available
                                        return (
                                          <img
                                            src={mediaUrl}
                                            alt={post.Content || 'Pending Post Media'}
                                            style={{
                                              width: '100%',
                                              height: '60px',
                                              objectFit: 'cover',
                                              borderRadius: '6px'
                                            }}
                                            onError={(e) => {
                                              e.target.style.display = 'none';
                                            }}
                                          />
                                        );
                                      }
                                    }
                                    // Show placeholder if no media
                                    return (
                                  <div
                                    className="d-flex flex-column align-items-center justify-content-center"
                                    style={{
                                      width: '100%',
                                      height: '60px',
                                      backgroundColor: '#e3f2fd',
                                      border: '2px solid #2196f3',
                                      borderRadius: '6px'
                                    }}
                                  >
                                    <FaFileAlt size={16} className="text-primary mb-1" />
                                    <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>
                                      No image Selected
                                    </small>
                                  </div>
                                    );
                                  })()}
                                </div>

                                <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                  <div className="small fw-bold mb-2" style={{
                                    fontSize: '12px',
                                    color: '#2e3192',
                                    maxHeight: '4.5em',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical'
                                  }}>
                                    {displayContent}
                                  </div>
                                  <div className="mt-2">
                                    <small className="text-muted" style={{ fontSize: '9px' }}>
                                      {post.ScheduledPostDate ? new Date(post.ScheduledPostDate).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        timeZone: 'UTC'
                                      }) : 'Recent'}
                                      
                                      &nbsp;{formatScheduledTime(post.ScheduledTimeAsPerZone) || 'Recent'}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <div className="text-muted">
                          <FaFileAlt size={32} className="mb-2" />
                          <p className="mb-0">No pending posts</p>
                          <small>All your posts are scheduled or posted!</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Approved Posts Card */}
              <div className="col-lg-6 col-md-12 mb-2">
                <div className="card border-0 shadow-sm h-100" style={{
                  borderRadius: '12px'
                }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          background: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #e9ecef'
                        }}>
                          <FaChartLine size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <div className="d-flex align-items-center mb-1">
                          <h6 className="mb-0 fw-bold me-2" style={{
                            fontSize: '1.1rem',
                            color: '#2e3192'
                          }}>
                            Approved Posts
                          </h6>
                          {!approvedPostsLoading && (
                            <span className="badge bg-success" style={{ fontSize: '12px', fontWeight: '600' }}>
                              {approvedPosts.length}
                            </span>
                          )}
                        </div>
                        <small className="text-muted">Recently approved content</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={loadApprovedPosts}
                        disabled={approvedPostsLoading}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px'
                        }}
                        title="Refresh approved posts"
                      >
                        <FaSync size={10} />
                      </button>
                      {approvedPostsLoading && (
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => navigate('/viewallapprovedposts')}
                        style={{
                          fontSize: '12px',
                          padding: '6px 12px',
                          borderRadius: '8px',
                          backgroundColor: '#fff',
                          color: '#2e3192',
                          border: '1px solid #fff',
                          fontWeight: '600'
                        }}
                      >
                        More
                      </button>
                    </div>
                  </div>
                  <div className="card-body p-3" style={{
                    maxHeight: '300px',
                    overflowY: 'auto'
                  }}>
                    {approvedPostsLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-success" role="status">
                          <span className="visually-hidden">Loading posts...</span>
                        </div>
                        <p className="mt-2 text-muted small">Loading approved posts...</p>
                      </div>
                    ) : approvedPosts.length > 0 ? (
                      <div className="row">
                        {approvedPosts.slice(0, 3).map((post, index) => {
                          // Check if this is a KnackFeed (has InterestsPromptID or PostSource is 'knackfeed')
                          const isKnackFeed = post.InterestsPromptID || post.PostSource === 'knackfeed';
                          const contentId = post.ContentId || post.ContentID;
                          
                          return (
                          <div key={`approved-post-${post.PostId || post.ContentId}-${index}`} className="col-md-4 mb-3">
                            <div 
                              className="card border-0 shadow-sm" 
                              style={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                padding: '12px',
                                height: '180px',
                                display: 'flex',
                                flexDirection: 'column',
                                cursor: 'pointer',
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                              }}
                              onClick={() => {
                                if (isKnackFeed && contentId) {
                                  navigate(`/updatelatesttrendingnews/${contentId}`);
                                } else {
                                  navigate(`/viewApprovedAigeneratedschedulepost/${post.ContentId || post.PostId}`);
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                              }}
                            >
                              <div className="mb-2">
                                {(() => {
                                  // Check for image/video in various possible fields (including challenge posts which use lowercase 'image')
                                  const mediaPath = post.Image || post.PostImage || post.image || post.ImageURL;
                                  const hasMedia = mediaPath && mediaPath !== '/assets/default-post-image.png' && mediaPath.trim() !== '';
                                  
                                  if (hasMedia) {
                                    const mediaUrl = getMediaUrl(mediaPath);
                                    const isVideo = isVideoFile(mediaPath);
                                    
                                    if (isVideo && mediaUrl) {
                                      // Show video if available
                                      return (
                                        <video
                                          src={mediaUrl}
                                          controls
                                          style={{
                                            width: '100%',
                                            height: '60px',
                                            objectFit: 'cover',
                                            borderRadius: '6px'
                                          }}
                                        >
                                          Your browser does not support the video tag.
                                        </video>
                                      );
                                    } else if (mediaUrl) {
                                    // Show image if available
                                    return (
                                      <img
                                          src={mediaUrl}
                                        alt={post.Content || post.ShortContent || 'Approved Post Image'}
                                        style={{
                                          width: '100%',
                                          height: '60px',
                                          objectFit: 'cover',
                                          borderRadius: '6px'
                                        }}
                                        onError={(e) => {
                                          // Hide broken image and show placeholder
                                          e.target.style.display = 'none';
                                        }}
                                      />
                                    );
                                    }
                                  } else {
                                    // Show "Approved" placeholder if no image
                                    return (
                                      <div
                                        className="d-flex flex-column align-items-center justify-content-center"
                                        style={{
                                          width: '100%',
                                          height: '60px',
                                          backgroundColor: '#e8f5e9',
                                          border: '2px solid #28a745',
                                          borderRadius: '6px'
                                        }}
                                      >
                                        <FaChartLine size={16} className="text-success mb-1" />
                                        <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>
                                          Approved
                                        </small>
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                              <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div className="small fw-bold mb-2" style={{
                                  fontSize: '12px',
                                  color: '#2e3192',
                                  maxHeight: '4.5em',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: 'vertical'
                                }}>
                                  {post.Content || post.ShortContent || post.Prompts || 'Approved Content'}
                                </div>
                                <div className="mt-2">
                                  <small className="text-muted" style={{ fontSize: '9px' }}>
                                    {post.ScheduledPostDate ? new Date(post.ScheduledPostDate).toLocaleDateString('en-US', {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric',
                                      timeZone: 'UTC'
                                    }) : 'Recent'} &nbsp;
                                    {formatScheduledTime(post.ScheduledTimeAsPerZone) || 'Recent'}

                                  </small>
                                
                                </div>
                              </div>
                            </div>
                          </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <div className="text-muted">
                          <FaFileAlt size={32} className="mb-2" />
                          <p className="mb-0">No approved posts</p>
                          <small>Approvals will appear here.</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* KnackFeeds and KnackChallenges */}
            <div className="row mb-3">
                {/* KnackFeeds Card */}
                <div className="col-lg-6 col-md-12 mb-2">
                  <div className="card border-0 shadow-sm h-100" style={{
                    borderRadius: '12px'
                  }}>
                    <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '8px',
                            background: '#f8f9fa',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #e9ecef'
                          }}>
                            <FaRobot size={20} style={{ color: '#2e3192' }} />
                          </div>
                        </div>
                        <div>
                          <h6 className="mb-0 fw-bold" style={{
                            fontSize: '1.1rem',
                            color: '#2e3192'
                          }}>
                            Knack Feeds
                          </h6>
                          <small className="text-muted">AI-powered content feeds</small>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={loadKnackFeeds}
                          disabled={knackFeedsLoading}
                          style={{
                            fontSize: '12px',
                            padding: '6px 12px',
                            borderRadius: '8px'
                          }}
                          title="Refresh knack feeds"
                        >
                          <FaSync size={10} />
                        </button>
                        {knackFeedsLoading && (
                          <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                        <button
                          className="btn btn-sm btn-light"
                          onClick={() => navigate('/knackfeeds')}
                          style={{
                            fontSize: '12px',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            color: '#2e3192',
                            border: '1px solid #fff',
                            fontWeight: '600'
                          }}
                        >
                          More
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-3" style={{
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}>
                      {knackFeedsLoading ? (
                        <div className="text-center py-4">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading feeds...</span>
                          </div>
                          <p className="mt-2 text-muted small">Loading latest feeds...</p>
                        </div>
                      ) : knackFeeds.length > 0 ? (
                        <div className="row">
                          {knackFeeds.slice(0, 3).map((feed, index) => (
                            <div key={`knack-feed-${feed.id || index}-${index}`} className="col-md-4 mb-3">
                              <div 
                                className="card border-0 shadow-sm" 
                                style={{
                                  backgroundColor: '#f8f9fa',
                                  borderRadius: '8px',
                                  padding: '12px',
                                  minHeight: '180px',
                                  height: '100%',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  cursor: 'pointer',
                                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                                }}
                                onClick={() => navigate(`/updatelatesttrendingnews/${feed.id || feed.ContentID}`)}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                  // Ensure background color stays the same on hover
                                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                  // Reset background color
                                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                                }}
                              >
                                {feed.ImageURL ? (
                                  <div className="mb-2">
                                    <img
                                      src={feed.ImageURL || '/assets/default-post-image.png'}
                                      alt={feed.Title || 'Feed Image'}
                                      style={{ width: '100%', height: '60px', objectFit: 'cover', borderRadius: '6px' }}
                                      onError={(e) => { e.target.style.display = 'none'; }}
                                    />
                                  </div>
                                ) : (
                                  <div className="mb-2">
                                    <div
                                      className="d-flex flex-column align-items-center justify-content-center"
                                      style={{ width: '100%', height: '60px', backgroundColor: '#e3f2fd', border: '2px solid #2196f3', borderRadius: '6px' }}
                                    >
                                      <FaRobot size={16} className="text-primary mb-1" />
                                      <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>No image</small>
                                    </div>
                                  </div>
                                )}
                                <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                  <div 
                                    className="small fw-bold mb-2" 
                                    style={{ 
                                      fontSize: '12px', 
                                      color: '#2e3192', 
                                      maxHeight: '2.4em', 
                                      overflow: 'hidden', 
                                      textOverflow: 'ellipsis', 
                                      display: '-webkit-box', 
                                      WebkitLineClamp: 2, 
                                      WebkitBoxOrient: 'vertical',
                                      textDecoration: 'none' // Prevent underline on hover
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.textDecoration = 'none';
                                      e.currentTarget.style.color = '#2e3192';
                                    }}
                                  >
                                    {feed.InterestsPromptData || 'Interest Prompt'}
                                  </div>
                                  <div className="small text-muted" style={{ fontSize: '10px', maxHeight: '3em', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                                    {feed.Content || 'Stay updated with the latest trends and insights...'}
                                  </div>
                                  <div className="mt-2">
                                    <small className="text-muted" style={{ fontSize: '9px' }}>
                                      {feed.CreatedDate ? new Date(feed.CreatedDate).toLocaleDateString() : 'Recent'}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center py-4">
                          <div className="text-muted">
                            <FaRobot size={32} className="mb-2" />
                            <p className="mb-0">No feeds available</p>
                            <small>Check back later for the latest updates!</small>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* KnackChallenges Card */}
                <div className="col-lg-6 col-md-12 mb-2">
                  <div className="card border-0 shadow-sm h-100" style={{
                    borderRadius: '12px'
                  }}>
                    <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '8px',
                            background: '#f8f9fa',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #e9ecef'
                          }}>
                            <FaTrophy size={20} style={{ color: '#2e3192' }} />
                          </div>
                        </div>
                        <div>
                          <div className="d-flex align-items-center mb-1">
                            <h6 className="mb-0 fw-bold me-2" style={{
                              fontSize: '1.1rem',
                              color: '#2e3192'
                            }}>
                              Knack Challenges
                            </h6>
                            {!challengesLoading && (
                              <span className="badge bg-primary" style={{ fontSize: '12px', fontWeight: '600' }}>
                                {knackChallenges.length}
                              </span>
                            )}
                          </div>
                          <small className="text-muted">Engage with community challenges</small>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={loadKnackChallenges}
                          disabled={challengesLoading}
                          style={{
                            fontSize: '12px',
                            padding: '6px 12px',
                            borderRadius: '8px'
                          }}
                          title="Refresh challenges"
                        >
                          <FaSync size={10} />
                        </button>
                        {challengesLoading && (
                          <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                        <button
                          className="btn btn-sm btn-light"
                          onClick={() => navigate('/knackchallenges')}
                          style={{
                            fontSize: '12px',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            color: '#2e3192',
                            border: '1px solid #fff',
                            fontWeight: '600'
                          }}
                        >
                          More
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-3" style={{
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}>
                      {challengesLoading ? (
                        <div className="text-center py-4">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading challenges...</span>
                          </div>
                          <p className="mt-2 text-muted small">Loading challenges...</p>
                        </div>
                      ) : knackChallenges.length > 0 ? (
                        <div className="row">
                          {knackChallenges.slice(0, 3).map((challenge, index) => (
                            <div key={`knack-challenge-${challenge.ChallengeID || index}-${index}`} className="col-md-4 mb-3">
                              <div 
                                className="card border-0 shadow-sm" 
                                style={{
                                  backgroundColor: '#f8f9fa',
                                  borderRadius: '8px',
                                  padding: '12px',
                                  height: '180px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  cursor: 'pointer',
                                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                                }}
                                onClick={() => navigate('/KnackChallenges')}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                }}
                              >
                                <div className="mb-2">
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      width: '100%',
                                      height: '60px',
                                      backgroundColor: '#e8f5e8',
                                      border: '2px solid #28a745',
                                      borderRadius: '6px'
                                    }}
                                  >
                                    <FaTrophy size={20} className="text-success" />
                                  </div>
                                </div>

                                <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div className="small fw-bold mb-2" style={{
                                  fontSize: '12px',
                                  color: '#2e3192',
                                    maxHeight: '3.6em',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical',
                                    lineHeight: '1.2em'
                                }}>
                                  {challenge.ChallengeTopic || 'Challenge'}
                                </div>
                                  <div style={{ marginTop: 'auto' }}>
                                    <div className="small text-muted mb-1" style={{
                                      fontSize: '10px'
                                }}>
                                  Duration: {challenge.Duration_Days || 0} days
                                </div>
                                    <div>
                                  <small className="text-muted" style={{ fontSize: '9px' }}>
                                    {(() => {
                                      if (!challenge.StartDate) return <span>Active</span>;
                                      const startDate = moment(challenge.StartDate).startOf('day');
                                      const today = moment().startOf('day');
                                      const hasStarted = startDate.isSameOrBefore(today);
                                      
                                      if (hasStarted && challenge.EndDate) {
                                        return (
                                          <>
                                            <i className="fa fa-calendar-times-o me-1" aria-hidden="true"></i>
                                            Ends: {new Date(challenge.EndDate).toLocaleDateString()}
                                          </>
                                        );
                                      } else {
                                        return (
                                          <>
                                            <i className="fa fa-calendar-check-o me-1" aria-hidden="true"></i>
                                            Starts: {new Date(challenge.StartDate).toLocaleDateString()}
                                          </>
                                        );
                                      }
                                    })()}
                                  </small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center py-4">
                          <div className="text-muted">
                            <FaTrophy size={32} className="mb-2" />
                            <p className="mb-0">No challenges available</p>
                            <small>Check back later for new challenges!</small>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            

            {/* Knack Moments (left) + Usage Limits (right) */}
            <div className="row mb-3">
              {/* Knack Moments Card (left) */}
              <div className="col-lg-6 col-md-12 mb-2">
                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e9ecef' }}>
                          <FaGift size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <h6 className="mb-0 fw-bold" style={{ fontSize: '1.1rem', color: '#2e3192' }}>Knack Moments</h6>
                        <small className="text-muted">Create and manage special moments</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <button className="btn btn-sm btn-outline-primary me-2" onClick={loadKnackMoments} disabled={knackMomentsLoading} style={{ fontSize: '12px', padding: '6px 12px', borderRadius: '8px' }} title="Refresh moments">
                        <FaSync size={10} />
                      </button>
                      {knackMomentsLoading && (
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      <button className="btn btn-sm btn-light" onClick={() => navigate('/KnackMoments')} style={{ fontSize: '12px', padding: '6px 12px', borderRadius: '8px', backgroundColor: '#fff', color: '#2e3192', border: '1px solid #fff', fontWeight: '600' }}>More</button>
                    </div>
                  </div>
                  <div className="card-body p-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {knackMomentsLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading moments...</span>
                        </div>
                        <p className="mt-2 text-muted small">Loading moments...</p>
                      </div>
                    ) : knackMoments.length > 0 ? (
                      <div className="row">
                        {knackMoments.slice(0, 3).map((momentItem, index) => (
                          <div key={`knack-moment-${momentItem.PostId || momentItem.ContentId || index}-${index}`} className="col-md-4 mb-3">
                            <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '12px', height: '160px', display: 'flex', flexDirection: 'column', cursor: 'pointer', transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out' }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)'; }}
                                onClick={() => handleViewMoment(momentItem)}>
                              <div style={{ flex: '0 0 auto' }}>
                                {(() => {
                                  // Check all possible video fields first
                                  const videoPath = momentItem.Video || momentItem.VideoURL;
                                  const imagePath = momentItem.Image || momentItem.PostImage || momentItem.image || momentItem.ImageURL;
                                  const mediaPath = videoPath || imagePath;
                                  
                                  if (mediaPath && mediaPath !== '/assets/default-post-image.png' && mediaPath !== 'uploaded' && mediaPath !== null && typeof mediaPath === 'string') {
                                    const mediaUrl = getMediaUrl(mediaPath);
                                    // Check if it's a video: has Video field, has VideoURL field, or has video file extension
                                    const isVideo = !!videoPath || isVideoFile(mediaPath);
                                    
                                    // Debug logging - only log if it might be a video to reduce console noise
                                    if (isVideo || mediaPath.toLowerCase().includes('video') || ['mp4', 'mov', 'avi', 'webm', 'mkv'].some(ext => mediaPath.toLowerCase().endsWith('.' + ext))) {
                                      console.log('Knack Moments VIDEO check:', {
                                        mediaPath,
                                        mediaUrl,
                                        isVideo,
                                        hasVideoField: !!videoPath,
                                        hasImageField: !!imagePath,
                                        fileExtension: mediaPath.split('.').pop()?.toLowerCase(),
                                        fullMomentItem: momentItem
                                      });
                                    }
                                    
                                    if (isVideo && mediaUrl) {
                                      // Show video if available
                                      return (
                                  <div className="mb-2">
                                          <video
                                            src={mediaUrl}
                                            controls
                                            preload="metadata"
                                            style={{
                                              width: '100%',
                                              height: '60px',
                                              objectFit: 'cover',
                                              borderRadius: '6px',
                                              backgroundColor: '#000'
                                            }}
                                            onError={(e) => {
                                              console.error('Video load error:', mediaUrl, e);
                                              e.target.style.display = 'none';
                                            }}
                                            onLoadedData={() => {
                                              console.log('Video loaded successfully:', mediaUrl);
                                            }}
                                          >
                                            Your browser does not support the video tag.
                                          </video>
                                  </div>
                                      );
                                    } else if (mediaUrl && !isVideo) {
                                      // Show image if available
                                      return (
                                        <div className="mb-2">
                                          <img
                                            src={mediaUrl}
                                            alt={momentItem.ShortContent || 'Moment Image'}
                                            style={{
                                              width: '100%',
                                              height: '60px',
                                              objectFit: 'cover',
                                              borderRadius: '6px'
                                            }}
                                            onError={(e) => {
                                              e.target.style.display = 'none';
                                            }}
                                          />
                                        </div>
                                      );
                                    }
                                  }
                                  // Show placeholder if no media
                                  return (
                                  <div className="mb-2">
                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: '100%', height: '60px', backgroundColor: '#e3f2fd', border: '2px solid #2196f3', borderRadius: '6px' }}>
                                      <FaFileAlt size={16} className="text-primary mb-1" />
                                      <small className="text-muted" style={{ fontSize: '8px', textAlign: 'center' }}>No image</small>
                                    </div>
                                  </div>
                                  );
                                })()}
                              </div>
                              <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
                                <div className="small fw-bold" style={{ fontSize: '12px', color: '#2e3192', maxHeight: '4.5em', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                                  {momentItem.ShortContent || momentItem.Content || 'Knack Moment'}
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-1" style={{ fontSize: '10px' }}>
                                  <small className="text-muted">
                                    {momentItem.PostScheduledTime ? new Date(momentItem.PostScheduledTime).toLocaleDateString() : 'Recent'}
                                  </small>
                                  {(() => {
                                    const raw = (momentItem.Status || momentItem.status || '').toString().toUpperCase();
                                    const isPosted = raw === 'POSTED';
                                    const isApproved = raw === 'APPROVED';
                                    const isPending = raw === 'PENDING';
                                    if (isPosted) return (<FaCheckCircle size={12} style={{ color: '#28a745' }} title="Posted" />);
                                    if (isApproved) return (<FaCheckCircle size={12} style={{ color: '#0d6efd' }} title="Approved" />);
                                    if (isPending) return (<FaClock size={12} style={{ color: '#ffc107' }} title="Pending" />);
                                    return (<FaClock size={12} style={{ color: '#6c757d' }} title={raw || 'Unknown'} />);
                                  })()}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <div className="text-muted">
                          <FaFileAlt size={32} className="mb-2" />
                          <p className="mb-0">No moments created</p>
                          <small>Create a moment to see it here</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Usage Limit Reports Card (right) */}
              <div className="col-lg-6 col-md-12 mb-2">
                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e9ecef' }}>
                          <FaChartLine size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <h6 className="mb-0 fw-bold" style={{ fontSize: '1.1rem', color: '#2e3192' }}>Usage Limit Reports</h6>
                        <small className="text-muted">Track your usage and limits</small>
                      </div>
                    </div>
                    <button className="btn btn-sm btn-light" onClick={() => navigate('/feature-limits')} style={{ fontSize: '12px', padding: '6px 12px', borderRadius: '8px', backgroundColor: '#fff', color: '#2e3192', border: '1px solid #fff', fontWeight: '600' }}>More</button>
                  </div>
                  <div className="card-body p-3">
                    {usageLimitsLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading usage limits...</span></div>
                        <p className="mt-2 text-muted small">Loading usage limits...</p>
                      </div>
                    ) : (
                      <>
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1"><span className="small">Knack Feeds</span><span className="small text-muted">{usageLimits.knack_feeds.used}/{usageLimits.knack_feeds.limit}</span></div>
                          <div className="progress" style={{ height: '8px' }}><div className={`progress-bar ${usageLimits.knack_feeds.used >= usageLimits.knack_feeds.limit ? 'bg-danger' : 'bg-success'}`} style={{ width: `${Math.min((usageLimits.knack_feeds.used / usageLimits.knack_feeds.limit) * 100, 100)}%` }}></div></div>
                        </div>
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1"><span className="small">Create Posts</span><span className="small text-muted">{usageLimits.manual_posts.used}/{usageLimits.manual_posts.limit}</span></div>
                          <div className="progress" style={{ height: '8px' }}><div className={`progress-bar ${usageLimits.manual_posts.used >= usageLimits.manual_posts.limit ? 'bg-danger' : 'bg-success'}`} style={{ width: `${Math.min((usageLimits.manual_posts.used / usageLimits.manual_posts.limit) * 100, 100)}%` }}></div></div>
                        </div>
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1"><span className="small">Schedule Posts</span><span className="small text-muted">{usageLimits.schedule_days.used}/{usageLimits.schedule_days.limit}</span></div>
                          <div className="progress" style={{ height: '8px' }}><div className={`progress-bar ${usageLimits.schedule_days.used >= usageLimits.schedule_days.limit ? 'bg-danger' : 'bg-success'}`} style={{ width: `${Math.min((usageLimits.schedule_days.used / usageLimits.schedule_days.limit) * 100, 100)}%` }}></div></div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Resources - Full width */}
            <div className="row mb-3">
              <div className="col-lg-12">
                <div className="card border-0 shadow-sm h-100" style={{
                  borderRadius: '12px'
                }}>
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          background: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #e9ecef'
                        }}>
                          <FaPlay size={20} style={{ color: '#2e3192' }} />
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-0 fw-bold" style={{
                          fontSize: '1.3rem',
                          color: '#2e3192'
                        }}>
                          Resources
                        </h5>
                        <small className="text-muted">Learn with our video tutorials</small>
                      </div>
                    </div>
                    <button
                      className="btn btn-sm btn-light"
                      onClick={() => navigate('/resources')}
                      style={{
                        fontSize: '12px',
                        padding: '6px 12px',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        color: '#2e3192',
                        border: '1px solid #fff',
                        fontWeight: '600'
                      }}
                    >
                      More
                    </button>
                  </div>
                  <div className="card-body p-4">
                    <div className="row">
                      {/* Main Overview Video - Larger */}
                      <div className="col-lg-8 mb-4">
                        <div className="text-center">
                          <div className="position-relative mb-3">
                            <iframe
                              width="100%"
                              height="250"
                              src="https://www.youtube.com/embed/VrmkPfr-zMM?si=U6y4tQkYfXQ8uU0R"
                              title="KnackVibes Overview"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                              allowFullScreen
                              style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                            ></iframe>
                          </div>
                          <small className="text-muted">See what makes us special</small>
                        </div>
                      </div>

                      {/* Side Videos - Smaller */}
                      <div className="col-lg-4 mb-4">
                        <div className="d-flex flex-column gap-3">
                          {/* Video 1 */}
                          <div className="text-center">
                            <div className="position-relative mb-2">
                              <iframe
                                width="100%"
                                height="90"
                                src="https://www.youtube.com/embed/EyQaE-q2rIM?si=yFyE3a1lQk7_rE6U"
                                title="Getting Started with KnackVibes"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                allowFullScreen
                                style={{ borderRadius: '6px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}
                              ></iframe>
                            </div>
                            <small className="text-muted" style={{ fontSize: '10px' }}>Quick start guide</small>
                          </div>

                          {/* Video 2 */}
                          <div className="text-center">
                            <div className="position-relative mb-2">
                              <iframe
                                width="100%"
                                height="90"
                                src="https://www.youtube.com/embed/TnI2uAzMjfw?si=2L5Wl1p3VhRrT-RJ"
                                title="Mastering Content Studio"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                allowFullScreen
                                style={{ borderRadius: '6px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}
                              ></iframe>
                            </div>
                            <small className="text-muted" style={{ fontSize: '10px' }}>Master the challenges</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </SideNavbar>
    </>
  );
};

export default Home;
